module.exports = __webpack_public_path__ + "img/certificate.0585d2c0.jpg";